import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'src/utils/axios'
import { backend, backendShop } from 'src/config'
import axiosInstance from 'src/utils/axios'

const appendShipmentQueryParams = (
  params,
  {
    page,
    offset,
    statusId,
    statusIds,
    id,
    incomingDeclaration,
    clientId,
    dpTrackNumber,
    registeredInUnitrade,
    sendingRegisterNumber,
  },
  { includePagination = true } = {}
) => {
  if (statusId) params.append('statusId', String(statusId))
  if (statusIds) params.append('statusIds', String(statusIds))
  if (incomingDeclaration)
    params.append('incomingDeclaration', incomingDeclaration)
  if (includePagination && page) params.append('page', String(page))
  if (includePagination && offset) params.append('offset', String(offset))
  if (id) params.append('id', String(id))
  if (clientId) params.append('clientId', String(clientId))
  if (dpTrackNumber) params.append('dpTrackNumber', String(dpTrackNumber))
  if (registeredInUnitrade !== undefined && registeredInUnitrade !== null)
    params.append('registeredInUnitrade', String(registeredInUnitrade))
  if (sendingRegisterNumber)
    params.append('sendingRegisterNumber', String(sendingRegisterNumber))
}

export const putShipment = createAsyncThunk(
  'PUT_SHIPMENT',
  async ({ id, data, enqueueSnackbar }, { rejectWithValue }) => {
    if (!id) return
    try {
      const response = await axios.put(
        `${backend}/api/manager/shipment/${id}`,
        data
      )
      enqueueSnackbar('Шипмент была успешно обновлена', {
        variant: 'success',
      })
      return response.data
    } catch (error) {
      // Интерсептор axios реджектит телом ответа сервера, поэтому сюда приходит объект
      // { timestamp, status, error, messageRu, path } без поля message. Передавать его в
      // enqueueSnackbar нельзя — notistack отрендерит объект как React child и упадёт.
      enqueueSnackbar(
        error?.messageRu || error?.message || 'Не удалось обновить шипмент',
        {
          variant: 'error',
        }
      )
      return rejectWithValue([], error)
    }
  }
)

export const checkProductShipmentDescription = createAsyncThunk(
  'CHECK_PRODUCT_SHIPMENT_DESCRIPTION',
  async ({ data, enqueueSnackbar = () => {} }, { rejectWithValue }) => {
    try {
      const { data: responseData } = await axiosInstance.post(
        `${backendShop}/api/product-goods-description`,
        data
      )

      enqueueSnackbar('Описание товара успешно создано', {
        variant: 'success',
      })
      console.log('responseData', responseData)
      return responseData
    } catch (error) {
      const errorMessage =
        error?.message || 'Мы не смогли создать описание товара'

      enqueueSnackbar(errorMessage, {
        variant: 'error',
      })

      return rejectWithValue(error)
    }
  }
)

export const fetchShipmentById = createAsyncThunk(
  'FETCH_SHIPMENT_BY_ID',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${backend}/api/manager/shipment/${id}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const fetchShipmentsData = createAsyncThunk(
  'FETCH_SHIPMENTS_DATA',
  async (
    {
      page = 1,
      offset = 50,
      statusId,
      statusIds,
      id,
      incomingDeclaration,
      clientId,
      dpTrackNumber,
      sendingRegisterNumber,
      registeredInUnitrade,
    },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams({ version: 'v2' })
      appendShipmentQueryParams(
        params,
        {
          page,
          offset,
          statusId,
          statusIds,
          id,
          incomingDeclaration,
          clientId,
          dpTrackNumber,
          registeredInUnitrade,
          sendingRegisterNumber,
        },
        { includePagination: true }
      )

      const response = await axios.get(
        `${backend}/api/manager/shipment?${params.toString()}`
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const exportShipmentsExcel = createAsyncThunk(
  'EXPORT_SHIPMENTS_EXCEL',
  async (
    {
      statusId,
      statusIds,
      id,
      incomingDeclaration,
      clientId,
      dpTrackNumber,
      sendingRegisterNumber,
      registeredInUnitrade,
    },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams({ version: 'v2' })
      appendShipmentQueryParams(
        params,
        {
          statusId,
          statusIds,
          id,
          incomingDeclaration,
          clientId,
          dpTrackNumber,
          sendingRegisterNumber,
          registeredInUnitrade,
        },
        { includePagination: false }
      )

      const response = await axiosInstance.get(
        `${backend}/api/manager/shipment/excel/export?${params.toString()}`,
        {
          headers: { accept: '*/*' },
          responseType: 'blob',
        }
      )

      return {
        data: response.data,
        headers: response.headers,
      }
    } catch (error) {
      return rejectWithValue(error?.message || 'Не удалось выгрузить файл')
    }
  }
)

export const fetchShipmentStatusHistory = createAsyncThunk(
  'FETCH_SHIPMENT_STATUS_HISTORY',
  async ({ shipmentId }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backend}/api/manager/shipment/status-history/${shipmentId}`
      )

      return data
    } catch (error) {
      console.log('Error while FETCH_SHIPMENT_STATUS_HISTORY', error)
      return rejectWithValue(error)
    }
  }
)

export const createShipmentWaifRegister = createAsyncThunk(
  'CREATE_SHIPMENT_WAIF_REGISTER',
  async ({ data, enqueueSnackbar = () => {} }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${backend}/api/manager/shipment/waif`,
        data
      )
      enqueueSnackbar('Шипмент зарегистрирован как потеряшка', {
        variant: 'success',
      })
      return response.data
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' })
      console.error('Error in CREATE_SHIPMENT_WAIF_REGISTER', error)
      return rejectWithValue({}, error)
    }
  }
)

export const putShipmentDeliveryTransaction = createAsyncThunk(
  'PUT_SHIPMENT_DELIVERY_TRANSACTION',
  async ({ incomingDeclaration, deliveryCost }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/manager/shipment/deliveryTransaction/${incomingDeclaration}?deliveryCost=${deliveryCost}`
      )
      return response?.data
    } catch (error) {
      console.error('Error in PUT_SHIPMENT_DELIVERY_TRANSACTION', error)
      return rejectWithValue(error)
    }
  }
)

export const putYiliShipment = createAsyncThunk(
  'PUT_YILI_SHIPMENT',
  async ({ shipmentId, enqueueSnackbar }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/yili/shipment/${shipmentId}`
      )
      enqueueSnackbar('Товар успешно зарегистрирован', {
        variant: 'success',
      })
      return response?.data
    } catch (error) {
      enqueueSnackbar('Мы не смогли зарегистрировать товар', {
        variant: 'error',
      })
      return rejectWithValue({}, error)
    }
  }
)
